import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ClearJunctionService } from '../services/clearjunction.service';
import { EditClearJTransactions } from '../editclearJtransactions/editclearJtransactions.component';
import { TransactionService } from '../services/transaction.service';
import { NotificationsService } from 'angular2-notifications';
@Component({
    selector: 'app-transactionsreport',
    templateUrl: './transactionsreport.component.html',
    styleUrls: ['./transactionsreport.component.css']
})

export class TransactionsReportComponent implements OnInit {
    displayedColumns1: string[] = [
        'transaction_date', 'transaction_type', 'inr_sent_received', 'client',
        'amount', 'price', 'net_amount', 'pending_settlement', 'buy_price', 'spread', 'pnl'
    ];
    displayedColumns: string[] = [
        'date', 'client', 'buy_quantity', 'buy_price',
        'sell_client', 'sell_quantity', 'sell_price', 'buy_price_again', 'spread', 'pnl', 'sell_date'
    ];

    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<any>;
    dataSource1: MatTableDataSource<any>;
    pageSize = 25;
    pageSize1 = 25;
    currentPage = 0;
    currentPage1 = 0;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    pageSizeOptions1: number[] = [5, 10, 25, 50, 100];
    @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
    @ViewChild('paginator1', { read: MatPaginator }) paginator1: MatPaginator;
    @ViewChild('sort', { read: MatSort }) sort: MatSort;
    @ViewChild('sort1', { read: MatSort }) sort1: MatSort;
    constructor(
        private userService: UserService,
        private service: TransactionService,
        public dialog: MatDialog,
        private notif: NotificationsService
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.applyINRRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async pageChanged(event: PageEvent) {
        this.pageSize = await event.pageSize;
        this.currentPage = await event.pageIndex;
    }
    async pageChanged1(event: PageEvent) {
        this.pageSize1 = await event.pageSize;
        this.currentPage1 = await event.pageIndex;
    }
    applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;

            this.service.transactionReport(this.filter).subscribe((res) => {
                const formattedData = [];

                res.data.forEach((deposit: any) => {
                    if (deposit.withdraws.length === 0) {
                        formattedData.push({
                            date: deposit.date,
                            client: deposit.client,
                            buy_quantity: deposit.buy_quantity,
                            buy_price: deposit.buy_price,
                            sell_client: '-',
                            sell_quantity: '-',
                            sell_price: '-',
                            spread: '-',
                            pnl: '-',
                            sell_date: '-'
                        });
                    } else {
                        deposit.withdraws.forEach((withdraw: any, index: number) => {
                            formattedData.push({
                                date: deposit.date,
                                client: deposit.client,
                                buy_quantity: deposit.buy_quantity,
                                buy_price: deposit.buy_price,
                                sell_client: withdraw.client,
                                sell_quantity: withdraw.sell_quantity,
                                sell_price: withdraw.sell_price,
                                spread: withdraw.spread,
                                pnl: withdraw.pnl,
                                sell_date: withdraw.date
                            });
                        });
                    }
                });
                const data = formattedData.map(d => {
                    return {
                        ...d,
                        date: d.date ? moment(d.date).format('MM/DD/YY') : '',
                        sell_date: d.sell_date ? moment(d.sell_date).format('MM/DD/YY') : ''
                    };
                });

                this.dataSource = new MatTableDataSource(data);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            });
        });
    }
    applyINRRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;

            this.service.inrTransactionReport().subscribe((res) => {
                const formattedData = res.data.map(d => {
                    d.pending_settlement = d.inr_sent_received - d.net_amount;
                    d.transaction_date = d.transaction_date ? moment(d.transaction_date).format('MM/DD/YY') : '';
                    return d;
                })

                this.dataSource1 = new MatTableDataSource(formattedData);
                this.dataSource1.paginator = this.paginator1;
                this.dataSource1.sort = this.sort1;
            });
        });
    }


    async exportArray() {
        if (this.dataSource.filteredData) {
            const txn_report = await this.dataSource.filteredData.map(x => ({
                date: x.date,
                client: x.client,
                buy_quantity: x.buy_quantity,
                buy_price: x.buy_price,
                usdt_amount: x.usdt_amount,
                sell_quantity: x.sell_quantity,
                sell_price: x.sell_price,
                spread: x.spread,
                pnl: x.pnl,
                sell_date: x.sell_date

            }));
            TableUtil.exportArrayToExcel(txn_report, "Txn_Report");
        }

    }
    async exportINRArray() {
        if (this.dataSource1.filteredData) {
            const inr_txn_report = await this.dataSource1.filteredData.map(x => ({
                Date: x.transaction_date,
                Type: x.transaction_type,
                Client: x.client,
                INR_Deposit: x.inr_sent_received,
                USDT_Sent: x.amount,
                Avg_Sell_Price: x.price,
                Net_Settlement: x.net_amount,
                Pending_Settlement: x.pending_settlement,
                Buy_Price: '',
                Spread: '',
                pnl: '',

            }));
            TableUtil.exportArrayToExcel(inr_txn_report, "INR_Txn_Report");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.filter._csrf = success._csrf;

            this.applyRefreshData();
        }, (error) => {
            if (error.status > 0) {
                this.notif.error(
                    'CSRF',
                    error.error.message,
                    {
                        timeOut: 5000,
                        showProgressBar: true,
                        pauseOnHover: true,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/transactionsreport/transactionsreport.component.ts